import React, { useEffect, useState } from "react";
import Rating from "react-rating";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import auth from "../../firebase.init";
import { useAuthState } from "react-firebase-hooks/auth";
import quote from "../../img/quote1.png";

const Reviews = () => {
  const [user] = useAuthState(auth);
  const [review, setreviwe] = useState([]);
  useEffect(() => {
    fetch(`http://localhost:5000/addreview`)
      .then((response) => response.json())
      .then((data) => setreviwe(data));
  }, []);

  return (
    <div>
      <h1 className="text-center text-5xl mt-3 text-cyan-800  font-serif">
        Customer Ratting
      </h1>
      <div className="grid md:grid-cols-3 gap-10 pt-7 pb-14 px-10">
        {review.slice(-3).map((review) => (
          <div className="p-4 w-full">
            <div
              className="bg-white drop-shadow-md p-8 rounded-lg"
              data-aos="zoom-in"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <img src={quote} width={30} alt="" className="pb-3" />
              <p className="h-[100px] leading-relaxed mb-6">{review.comment}</p>
              <a className="inline-flex items-center">
                <img
                  alt=""
                  src={review.image}
                  className="w-14 h-14 rounded-full flex-shrink-0 object-cover object-center"
                />
                <span className="flex-grow flex flex-col pl-4">
                  <p>
                    <Rating
                      readonly
                      initialRating={review.ratting}
                      emptySymbol={
                        <AiOutlineStar color="orange" size={"15px"} />
                      }
                      fullSymbol={<AiFillStar color="orange" size={"15px"} />}
                    />
                  </p>
                  <span className="title-font font-medium text-violet-800">
                    {review.name}
                  </span>
                </span>
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reviews;
